import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faDownload, faTrashCan, faFile} from "@fortawesome/free-solid-svg-icons";
import {Fragment} from "react";
import {Tooltip} from "~/components";
import {format} from "date-fns";
function FilePreview({src, imageFile = true, fileName, fileSize, handleRemoveClick, disabled = false, showDownloadFile = false, createdDate}) {
    const handlePreviewFile = () => {
        try {
            const link = document.createElement("a");
            link.href = src;
            link.download = fileName || "download";
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error(error);
        }
    }

    const handleDownLoadFile = async  () => {
        try {
            const response = await fetch(src, { mode: "cors" });
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = fileName || "download";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <div className="border-bottom border-translucent d-flex align-items-center justify-content-between py-3">
            <div aria-disabled={disabled} className="text-decoration-none d-flex align-items-center">
                <div className="btn-icon btn-icon-lg rounded-3 flex-column me-2 position-relative text-body-quaternary">
                    {imageFile ? (
                        <img alt={fileName} className="w-100 rounded" src={src}/>
                    ) : (
                        <FontAwesomeIcon icon={faFile} className="fs-2 text-secondary fs-7" />
                    )}
                </div>
                <div className="flex-1">
                    <h6 className="line-clamp-1 text-break text-body">{fileName}</h6>
                    <div className="d-flex align-items-center lh-1 fw-semibold fs-10 text-body-tertiary">
                        <p className="mb-0 text-nowrap">{fileSize}{createdDate && <span className='text-primary ms-2'>({format(new Date(createdDate), "dd-MM-yyyy")})</span>}</p>
                    </div>
                </div>
            </div>
            <div>
                {
                    !disabled &&
                    (
                        <button className="btn p-0" onClick={handleRemoveClick} type="button">
                            <FontAwesomeIcon icon={faTrashCan} className="fs-0"/>
                        </button>
                    )
                }
                {
                    showDownloadFile && (
                        <Fragment>
                            <Tooltip placement="top" text="View File">
                                <button className="btn p-0 me-2" onClick={handlePreviewFile} type="button">
                                    <FontAwesomeIcon icon={faFile} className="text-primary"/>
                                </button>
                            </Tooltip>
                            <Tooltip placement="top" text="Download File">
                                <button className="btn p-0" onClick={handleDownLoadFile} type="button">
                                    <FontAwesomeIcon icon={faDownload} className="text-danger"/>
                                </button>
                            </Tooltip>
                        </Fragment>
                    )
                }
            </div>
        </div>
    )
}

export default FilePreview;